const URLS_TO_IGNORE_REFRESH_TOKEN = [
  'v2/accounts/me',
  '/api/v1/trapview',
  '/api/v1/john-deere',
  'remote-sensing',
  '.amazonaws.com',
  'v2/catalog/products/ids',
  'v2/accounts'
];

const URLS_TO_IGNORE_ADDITION_HEADERS = [
  'remote-sensing',
  'v2/catalog/crops',
  '.amazonaws.com',
  'v2/catalog/orgs',
  'v2/catalog/products/ids',
  /\/v2\/catalog\/orgs\/[0-9a-fA-F-]{36}\/products$/
];

export { URLS_TO_IGNORE_ADDITION_HEADERS, URLS_TO_IGNORE_REFRESH_TOKEN };
